import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FacebookIcon, InstagramIcon, LockIcon, MenuIcon, XIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navItems } from "../data/navigation";
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-white/95 backdrop-blur transition-[box-shadow,border-color] duration-200 ${scrolled ? "border-b border-line shadow-sm" : "border-b border-transparent"}`} data-id="element-65" data-mp="31d9xeu0d8n9u">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-66" data-mp="3b81xq5lc1o8b">
        <Logo data-id="element-67" data-mp="3f9nh89sdh0rh" />

        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-68" data-mp="2wkupx3y541b1">
          <ul className="flex items-center gap-8" data-id="element-69" data-mp="2wirn1jbw2dow">
            {navItems.map(item => <li key={item.label} data-id="element-70" data-mp="2rkgf5e55md9b">
                <a href={item.href} className="whitespace-nowrap text-sm font-medium text-ink/80 transition-colors duration-150 hover:text-brand" data-id="element-71" data-mp="2mmeuios2y5vq">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="hidden items-center gap-5 lg:flex" data-id="element-72" data-mp="3abpqzu2ede42">
          <div className="flex items-center gap-1" data-id="element-73" data-mp="3aec4sbfvspuq">
            <a href="#" aria-label="Instagram" className="rounded-full p-2 text-muted transition-colors duration-150 hover:text-brand" data-id="element-74" data-mp="35khfmshibio9">
              <InstagramIcon className="h-4 w-4" data-id="element-75" data-mp="30kd8vu6ei2b8" />
            </a>
            <a href="#" aria-label="Facebook" className="rounded-full p-2 text-muted transition-colors duration-150 hover:text-brand" data-id="element-76" data-mp="1xhcfpwpmnuw">
              <FacebookIcon className="h-4 w-4" data-id="element-77" data-mp="3t90opa8drzhe" />
            </a>
          </div>
          <a href="#" className="flex items-center gap-2 whitespace-nowrap rounded-full bg-ink px-5 py-2.5 text-sm font-medium text-white transition-colors duration-150 hover:bg-brand" data-id="element-78" data-mp="1re367vgbqsfv">
            <LockIcon className="h-3.5 w-3.5" data-id="element-79" data-mp="1hlnmaslgvtsc" />
            Espace client
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} className="rounded-full p-2 text-ink lg:hidden" data-id="element-80" data-mp="1mki5vwr9dmdi">
          {open ? <XIcon className="h-6 w-6" data-id="element-81" data-mp="yq7df1tvlkod" /> : <MenuIcon className="h-6 w-6" data-id="element-82" data-mp="yr0cdgmlf5vy" />}
        </button>
      </div>

      <AnimatePresence data-id="element-83" data-mp="13os3w9jbspzm">
        {open && <motion.nav aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-white px-6 pb-6 lg:hidden" data-id="element-84" data-mp="2t2x83ls2ixwt">
            <ul className="divide-y divide-line" data-id="element-85" data-mp="hgweecddbvia">
              {navItems.map(item => <li key={item.label} data-id="element-86" data-mp="w5j334ovxzm6">
                  <a href={item.href} onClick={() => setOpen(false)} className="block py-4 text-base font-medium text-ink" data-id="element-87" data-mp="w6ki1k90v696">
                    {item.label}
                  </a>
                </li>)}
            </ul>
            <a href="#" className="mt-4 flex items-center justify-center gap-2 rounded-full bg-ink px-5 py-3 text-sm font-medium text-white" data-id="element-88" data-mp="106bcbxxrc4ig">
              <LockIcon className="h-3.5 w-3.5" data-id="element-89" data-mp="1f2tqns15n4ls" />
              Espace client
            </a>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}